import qs from 'qs'
import instance from '@/helpers/axios'
import moment from 'moment'
import numeral from 'numeral'

const state = {
    event_beginDate: null,
    event_lastDate: null,
    event_datasets: [],
    //v2
    event_isLoading: false,
    event_table: null,
    event_total: 0,
    event_year: {},
}

// getters
const getters = {
    event_data_date: state => {
        // return state.event_beginDate + " and " + state.event_lastDate;
        if (state.event_year.selected !== undefined) {
            return state.event_year.selected;
        } else {
            return "N/A"
        }
    },
    event_datasets: state => {
        return state.event_datasets;
    },
    event_table: state => {
        return state.event_table;
    },
    event_year: state => {
        return state.event_year;
    },
    event_isLoading: state => {
        return state.event_isLoading;
    },
}

// actions
const actions = {
    getEventDatasets(context, payload) {
        state.event_isLoading = true;
        var _params = {};
        // calulate _params from main_filters                
        var main_filters = payload.main_filters;
        if (main_filters !== null) {
            if (main_filters.location_destination != null) {
                _params.location_destination = main_filters.location_destination;
            }
            if (main_filters.year != null) {
                _params.year = main_filters.year;
            }
        }

        // calulate _params from sub_filters
        // yearmonth, q, limit, page, sort
        _params.limit = 5;
        _params.page = 1;
        var sub_filter = payload.sub_filter;
        if (sub_filter !== null) {
            if (sub_filter.yearmonth !== null) {
                _params.yearmonth = sub_filter.yearmonth;
            }
            if (sub_filter.q !== "") {
                _params.q = sub_filter.q;
            }
            if (sub_filter.limit > 0) {
                _params.limit = sub_filter.limit;
            }
            if (sub_filter.page > 0) {
                _params.page = sub_filter.page;
            }
            if (sub_filter.sort != "") {
                _params.sort = sub_filter.sort;
            }
        }

        const request = {
            params: qs.parse(_params)
        };

        instance.get('market/event', request)
            .then(response => {
                const { year, count, rows } = response.data;
                state.event_total = count
                state.event_year = year;
                state.event_datasets = rows;

                payload.stateDatasets.forEach(function(stateName) {
                    if (stateName == "event_table") {
                        context.commit("onEventTable", rows);
                    }
                })
                state.event_isLoading = false;
            })
            .catch(error => {
                console.log(error.response, "[store/market/event] syntax errors under instant.get");
            })

    }
}

// mutations
const mutations = {
    onEventTable(state, payload) {
        // --- start dataset for v-data-table
        /**
        {
            "id": "5be437e63ea594000654669a",
            "event_title": "ไทยเที่ยวไทย ครั้งที่ 60",
            "event_location": "IMPACT เมืองทองธานี",
            "event_province": "ศรีสะเกษ",
            "event_date_start": "2018-02-02T00:00:00.000Z",
            "event_date_end": "2018-04-02T00:00:00.000Z",
            "event_time": "10:00-21:00น.",
            "event_description": "เตรียมพบกับมหกรรมท่องเที่ยวครั้งยิ่งใหญ่แห่งปี กับงานไทยเที่ยวไทยครั้งที่ 49 พร้อมโปรโมชั่นพิเศษให้ผู้รักการท่องเที่ยวได้เลือกซื้อ และชมจุใจ ทั้งแพ็คเกจทัวร์ โรงแรม รีสอร์ สายการบิน สปา รถเช่า เรือท่องเที่ยว อุปกรณ์เดินทาง และท่องเที่ยวครบครันมากมาย_",
            "event_tags": [
                "โรงแรม",
                "เกสต์เฮาส์",
                "เกาะเสม็ด"
            ],
            "event_contact_detail": "บริษัท พี.เค. เอ็กซิบิชั่น แมนเนจเม้นท์ จำกัด_โทร. 02-307-8555_เว็บไซต์ thaiteawthaiplaza.com_อีเมล sales@pkexhibition.com_",
            "event_image": "http://www.thailandexhibition.com/images/fileupload/EXPO_15103.jpg",
            "event_source": "thailandexhibition",
            "event_page_url": "http://www.thailandexhibition.com/TradeShow-2018/15103",
            "event_datecollected": "2018-07-02T00:00:00.000Z",
            "year": 2018,
            "yearmonth": "20182"
        }
        */
        var rows = state.event_datasets;
        var event_datatable = {
            headers: [
                { text: 'Date', value: "event_date_start", align: 'left', style: 'width:120px;' },
                { text: 'Title', value: "event_title", align: 'left', style: 'width:200px;' },
                { text: 'Description', value: "event_description", align: 'left' },
                { text: 'Destination', value: "event_province", align: 'left' },
                { text: 'Link', value: "event_page_url", align: 'center' },
            ],
            items: [{
                value: false,
                event_date_start: '',
                event_title: '',
                event_description: '',
                event_province: '',
                event_page_url: '',
            }],
            pagination: {
                sortBy: 'event_date_start',
                descending: false,
            },
            total: 0,
        };

        // build items
        var items = [];
        rows.forEach(function(item, index) {
            var _item = {
                value: false,
                event_date_start: item.event_date_start,
                event_title: item.event_title,
                event_description: item.event_description,
                event_province: item.event_province,
                event_page_url: item.event_page_url,
            }
            items.push(_item);
        });
        event_datatable.items = items;
        event_datatable.total = state.event_total;
        state.event_table = event_datatable;
        // --- start dataset for v-data-table



    }
}

export default {
    state,
    getters,
    actions,
    mutations
}